import { Box, Checkbox, IconButton, Typography } from '@mui/material';
import React, { useContext } from 'react';
import { Tag } from '../../../../models/common-types';
import { GlobalContext } from '../../../../contexts/globalContext';
import { IconCheckboxSelected, IconCheckboxUnselected, IconEdit } from '../../../../images';
import { SECTION } from '../../../../constants/constants';
import { COLORS } from '@cellebrite/saas-ui-common';
import { useQueryClient } from 'react-query';

interface TagRowProps {
    tag: Tag;
    section: string;
    elementId: string;
    setLoading: any;
    setEditTag: any;
    setTags: any;
}

const TagRow: React.FC<TagRowProps> = ({ tag, section, elementId, setLoading, setEditTag, setTags }) => {
    const { tagsData, reportData } = useContext(GlobalContext);
    const queryClient = useQueryClient();
    const handleCheck = () => {
        setLoading(true);
        tagsData.addTag({
            data: { tagId: tag.id, elementId: elementId },
            successCallback: async function (tags) {
                await queryClient.invalidateQueries(SECTION.SUMMARY);
                await queryClient.invalidateQueries(section);
                if (section === SECTION.INSIGHTS) {
                    await queryClient.invalidateQueries(SECTION.CONNECTIONS);
                    await queryClient.invalidateQueries(SECTION.POSTS);
                } else if (section === SECTION.CONNECTIONS || section === SECTION.POSTS) {
                    await queryClient.invalidateQueries(SECTION.INSIGHTS);
                } else if (section === SECTION.PERSONAL_INFO) {
                    await queryClient.invalidateQueries(SECTION.MEDIA);
                } else if (section === SECTION.MEDIA) {
                    await queryClient.invalidateQueries(SECTION.PERSONAL_INFO);
                }

                if (setTags) {
                    queryClient.invalidateQueries(section);
                    setTags?.(tags);
                }
                setLoading(false);
            },
            errorCallback: function (): void {
                setLoading(false);
            },
        });
    };
    return (
        <Box
            sx={{
                'display': 'flex',
                'alignItems': 'center',
                '&:hover': {
                    backgroundColor: COLORS.MUTED_HOVER,
                },
                '&:hover button': {
                    display: tag.editable ? 'flex' : null,
                },
                'justifyContent': 'space-between',
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center' }} onClick={() => handleCheck()}>
                <Checkbox checkedIcon={<IconCheckboxSelected />} icon={<IconCheckboxUnselected />} />
                <Box
                    sx={{
                        width: 12,
                        height: 12,
                        backgroundColor: tag.color,
                        borderRadius: 2,
                        mr: 1,
                        ml: 1,
                    }}
                ></Box>
                <Typography variant="s14w500">{tag.name}</Typography>
            </Box>
            <IconButton onClick={() => setEditTag(tag)} sx={{ mr: 1, display: 'none' }}>
                <IconEdit className="fill-md" />
            </IconButton>
        </Box>
    );
};

export default TagRow;
